var styles = {"dropContainer":"styles_drop-container__bDnsm","dropOverlay":"styles_drop-overlay__1uIa-","dropOverlayIcon":"styles_drop-overlay-icon__-2O9j","draggedOver":"styles_dragged-over__A0B-K"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
